import { RouterStateSerializer, routerReducer } from '@ngrx/router-store';
import { RouterStateSnapshot } from '@angular/router';

import * as fromModels from '../../models/router.model';

export const reducers = {
    router: routerReducer
};

export class CustomRouterSerializer implements RouterStateSerializer<fromModels.RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): fromModels.RouterStateUrl {

        let route = routerState.root;
        while (route.firstChild) {
            route = route.firstChild;
        }

        const {
            url,
            root: { queryParams },
        } = routerState;

        const { params, data } = route;


        return { url, params, queryParams, data };
    }
}
